import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export const exportRouteActivityPdf = (data) => {
    // 1. Creamos el documento en horizontal (landscape)
    const doc = new jsPDF('landscape', 'pt', 'a4');

    // 2. Título del documento
    doc.setFontSize(18);
    doc.setTextColor(31, 41, 55); // Color oscuro
    doc.text('Reporte Semanal: Actividad de Rutas', 40, 40);
    
    doc.setFontSize(10);
    doc.setTextColor(107, 114, 128); // Color gris
    doc.text(`Generado el: ${new Date().toLocaleDateString()} a las ${new Date().toLocaleTimeString()}`, 40, 55);

    // 3. Preparamos las cabeceras (Acortadas para que quepan bien)
    const head = [[
        "Ciudad", "Ruta", "Conductor / Bus",
        "Lun", "H", "Mar", "H", "Mié", "H", 
        "Jue", "H", "Vie", "H", "Sáb", "H", "Dom", "H",
        "Promedio", "Total"
    ]];

    // 4. Preparamos el cuerpo y agrupamos para unir celdas (rowSpan)
    const grouped = data.reduce((acc, curr) => {
        if (!acc[curr.cityName]) acc[curr.cityName] = [];
        acc[curr.cityName].push(curr);
        return acc;
    }, {});

    const body = [];

    Object.entries(grouped).forEach(([cityName, routes]) => {
        let cityRowSpan = routes.reduce((sum, route) => sum + Math.max(route.buses.length, 1), 0);
        let isFirstCity = true;

        routes.forEach(route => {
            let routeRowSpan = Math.max(route.buses.length, 1);
            let isFirstRoute = true;
            const buses = route.buses.length > 0 ? route.buses : [null];

            buses.forEach(bus => {
                const row = [];
                
                // Unir celdas de la ciudad
                if (isFirstCity) {
                    row.push({ content: cityName, rowSpan: cityRowSpan, styles: { valign: 'middle', fontStyle: 'bold', fillColor: [243, 244, 246] } });
                    isFirstCity = false;
                }

                // Unir celdas de la ruta
                if (isFirstRoute) {
                    row.push({ content: route.routeName, rowSpan: routeRowSpan, styles: { valign: 'middle', fontStyle: 'bold', fillColor: [249, 250, 251] } });
                    isFirstRoute = false;
                }

                // Llenar datos del bus
                if (bus) {
                    row.push(`${bus.driver}\nBus ${bus.busId} (${bus.plate})`);
                    
                    bus.streak.forEach(day => {
                        row.push({ content: day.active && day.schedule ? day.schedule.replace(/ AM| PM/g, '') : '-', styles: { textColor: day.active ? [55, 65, 81] : [156, 163, 175] } });
                        row.push({ content: day.active ? (day.hours < 1 ? '< 1h' : day.hours + 'h') : '0h', styles: { textColor: day.active ? [16, 185, 129] : [156, 163, 175], fontStyle: 'bold' } });
                    });
                    
                    row.push(bus.avgSchedule);
                    row.push({ content: bus.totalHours < 1 ? '< 1h' : bus.totalHours + 'h', styles: { textColor: [16, 185, 129], fontStyle: 'bold', fillColor: [236, 253, 245] } });
                } else {
                    row.push({ content: 'Sin unidades activas', colSpan: 17, styles: { textColor: [239, 68, 68], halign: 'center' } });
                }

                body.push(row);
            });
        });
    });

    // 5. Dibujamos la tabla en el PDF
    autoTable(doc, {
        startY: 70,
        head: head,
        body: body,
        theme: 'grid', // Esto fuerza a que dibuje todas las cuadrículas
        styles: {
            lineWidth: 0.5, // Grosor de las líneas generales
            lineColor: [209, 213, 219], // Color gris claro para los bordes del cuerpo
        },
        headStyles: { 
            fillColor: [16, 185, 129], // Verde corporativo
            textColor: [255, 255, 255],
            fontSize: 8,
            halign: 'center',
            valign: 'middle',
            // 🔥 AQUÍ ESTÁ EL ARREGLO DE TUS LÍNEAS DE CABECERA 🔥
            lineWidth: 0.5, 
            lineColor: [255, 255, 255] // Líneas blancas para separar las columnas verdes
        },
        bodyStyles: { 
            fontSize: 7, 
            halign: 'center',
            valign: 'middle'
        },
        columnStyles: {
            0: { halign: 'left', cellWidth: 70 },  // Ancho fijo Ciudad
            1: { halign: 'left', cellWidth: 100 }, // Ancho fijo Ruta
            2: { halign: 'left', cellWidth: 90 }   // Ancho fijo Conductor
            // El resto se ajusta solo
        },
        margin: { top: 40, right: 20, bottom: 40, left: 20 }
    });

    // 6. ¡DESCARGA DE GOLPE SIN IMPRIMIR!
    doc.save('Reporte_Actividad_Rutas.pdf');
};